import React from 'react';
import '../style/css/homepage2026.css';
import LoadDistribution from '../comps/homepage/LoadDistribution';
import NotifhpContainer from '../comps/homepage/NotifhpContainer';
import InvitedSoonContainer from '../comps/homepage/InvitedSoonContainer';

function HomePage() {
    return (
        <div className="hp-page">
            <LoadDistribution />
            <NotifhpContainer />
            <InvitedSoonContainer />
        </div>
    );
}

export default HomePage;
